import * as React from "react";
import { forwardRef } from "react";
const SvgComparisonItemPurposeFlagNone = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "#5F6875", strokeLinecap: "round", d: "M4.5 9.5h11" }));
const ForwardRef = forwardRef(SvgComparisonItemPurposeFlagNone);
export { ForwardRef as ReactComponent };
